<template>
  <div>
    <transition name="fade" mode="out-in">
      <div class="card p-4 mb-3" v-if="!isLocationSet">
        <h5 class="helper">
          <vue-typer
            :text="[hello]"
            :repeat="0"
            :pre-type-delay="70"
            :type-delay="30"
            :erase-on-complete="false"
            @typed="
              typingOver();
              colorNumbers();
            "
            @typed-char="onTypedChar"
          ></vue-typer>
        </h5>
      </div>
    </transition>    

    <transition name="fade" mode="out-in">
      <div class="card p-4 mb-3" v-if="isLocationSet && isBigCity && !isSurfaceMinSet">
        <h5 class="helper">
          <vue-typer
            :text="[finalMsgBigCity]"
            :repeat="0"
            :pre-type-delay="70"
            :type-delay="30"
            :erase-on-complete="false"
            @typed="
              typingOver();
              colorLastNumber();
            "
            @typed-char="onTypedChar"
          ></vue-typer>
        </h5>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="card p-4 mb-3" v-if="isLocationSet && !isBigCity && !isSurfaceMinSet">
        <h5 class="helper">
          <vue-typer
            :text="[finalMsg]"
            :repeat="0"
            :pre-type-delay="70"
            :type-delay="30"
            :erase-on-complete="false"
            @typed="
              typingOver();
              colorNumbers();
            "
            @typed-char="onTypedChar"
          ></vue-typer>
        </h5>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div class="card p-4 mb-3" v-if="isLocationSet && isSurfaceMinSet && previsionCount !== null">
        <h5 class="helper">
          <vue-typer
            :text="[previsionCountMsg]"
            :repeat="0"
            :pre-type-delay="400"
            :type-delay="30"
            :erase-on-complete="false"
            @typed="
              typingOver();
              colorNumbers();
            "
            @typed-char="onTypedChar"
          ></vue-typer>
        </h5>
      </div>
    </transition>
  </div>
</template>

<script>
import { VueTyper } from "vue-typer";
import { mapGetters, mapState } from "vuex";
import MapFrance from "@/components/content/MapFrance.vue";
import typer from "./../../utilities/typer.js";

export default {
  extends: typer,
  components: {
    VueTyper,
    MapFrance,
  },
  data() {
    return {
      isTypingOver: false,
      countWord: 0,
      randomAdCount: Math.floor(Math.random() * (24 - 18 + 1)) + 18,
      randomHourCount: Math.floor(Math.random() * (4 - 2 + 1)) + 2,
    };
  },

  computed: {
    previsionCountMsg() {
      if (this.previsionCount === 0)
        return "Selon vos critères, vous allez recevoir moins d'une annonce par jour 👀.\n\nElargissez-les si vous souhaitez en recevoir +";
      if (this.previsionCount === 1)
        return "Selon vos critères, vous allez recevoir ≈ 1 annonce chaque jour.\n\nElargissez-les si vous souhaitez en recevoir +";
      if (this.previsionCount > 1 && this.previsionCount < 16)
        return `Selon vos critères, vous allez recevoir ≈ ${this.previsionCount} annonces chaque jour. 🌈`;
      if (this.previsionCount > 16 && this.previsionCount < 100)
        return `Selon vos critères, vous allez recevoir ≈ ${this.previsionCount} annonces chaque jour.\n\nEssayez d'affiner votre recherche si vous trouvez que c'est un peu beaucoup.`;
      if (this.previsionCount > 100)
        return `Selon vos critères, vous allez recevoir plus de 100 annonces chaque jour.\n\nAffinez votre recherche pour continuer.`;
    },
    hello() {
      return "Bonjour, je suis Teddi le petit ours expert de l'immobilier.\n\nJe couvre toute la France et bientôt l'Europe.";
    },
    finalMsgBigCity() {
      return `À ${this.getFirstSelectedLocation}, les annonces les plus attractives sont retirées en moins de ${this.randomHourCount} heures.\n\nJe peux vous aider à ne pas passer à côté de ces annonces. 🌈`;
    },
    finalMsg() {
      return `À ${this.getFirstSelectedLocation}, les annonces les plus attractives peuvent être retirées rapidement.\n\nJe peux vous aider à ne pas passer à côté de ces annonces. 🌈`;
    },
    ...mapGetters([
      "isTransactionTypeSet",
      "isPropertyTypeSet",
      "isLocationSet",
      "isBudgetMaxSet",
      "isSurfaceMinSet",
      "isBedroomMinSet",
      "isEmailSet",
      "getFirstSelectedLocation",
      "isBigCity",
    ]),
    ...mapState({
      userSearch: state => state.userSearch,
      pointedLocation: "pointedLocation",
      previsionCount: "previsionCount",
    }),
  },
  methods: {
    colorCity() {
      let cityLength = this.getFirstSelectedLocation.length;
      for (let i = 1; i <= cityLength; i++) {
        document
          .querySelector(`.vue-typer > .left > .nowrap:nth-of-type(2) > .typed:nth-of-type(${i})`)
          .classList.add("text-blue");
      }
    },
    colorString() {
      for (let i = 1; i <= 4; i++) {
        document
          .querySelector(`.vue-typer > .left > .nowrap:nth-of-type(31) > .typed:nth-of-type(${i})`)
          .classList.add("text-blue");
      }
    },
  },
  watch: {
    userSearch: {
      handler() {
        if (
          this.isLocationSet &&
          this.isBudgetMaxSet &&
          this.isTransactionTypeSet &&
          this.isPropertyTypeSet
        )
          this.$store.dispatch("fetchPrevisionCount");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/cards.scss";

.helper {
  text-align: left;
  margin-bottom: 0;
}
::v-deep {
  .vue-typer .custom.caret {
    display: none;
  }
}
</style>
